<template>
  <div>
    <h2>会员中心</h2>
    <a-divider></a-divider>
    <a-card class="search-card" :bordered="false">
      <template>
        <a-tooltip>
          <template #title>到期时间：{{vip_level.vipEnd}}</template>
          我的会员等级： <span v-if="vip_level.level === 0" style="color: #b6b6b6;">普通会员</span>
          <span v-else-if="vip_level.level === 1" style="color: green;">{{vip_level.name}}</span>
          <span v-else-if="vip_level.level === 2" style="color: orange;">{{vip_level.name}}</span>
          <span v-else-if="vip_level.level === 3" style="color: red;">{{vip_level.name}}</span>
          <span v-else style="color: red;">{{vip_level.name}}</span>
        </a-tooltip>
      </template>
      <br><br>


      <a-table
        class="j-table-force-nowrap"
        :scroll="{x:true}"
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="vipDataSource"
        :pagination="pagination"
        :loading="loading"
      >
        <span slot="days" slot-scope="text, record">
          {{ text }} 天
        </span>

        <span slot="action" slot-scope="text, record">
          <a-button @click="createVipOrder(record.id,record.price)">购买</a-button>
        </span>
      </a-table>
    </a-card>
    <template>
    <a-modal
        title="扫码支付"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @cancel="handleCancel"
        cancelText="关闭"
        @ok="handleOk"
        okText="我已完成支付?"
        wrapClassName="ant-modal-cust-warp"
        style="top:5%;height: 85%;overflow-y: hidden">

        <div style="border: 1px solid #F5F5F5; height: 300px; width: 70%;margin-left: 120px;">
          <div style="padding: 16px;"><img src="@/assets/wxlogo.png" style="width:100px;height:25px" /></div>
          <div style="text-align: center;">
            <canvas ref="qrcodeCanvas"></canvas>
            <div>请使用微信扫码二维码完成支付</div>
          </div>
        </div>
    </a-modal>
    </template>

  </div>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import {getAction, postAction} from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import {getDict} from "@api/sys";
var QRCode = require('qrcode')
var canvas = ''
export default {
  name: "vip",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag
  },

  data() {
    return {
      vip_level: {level:0,name:'',vipEnd:''},
      levels: [],
      vipDataSource: [],
      visible: false,
      payUrl: '',
      confirmLoading: false,
      columns: [
        {
            title:'会员等级',
            align:"center",
            dataIndex: 'vipLevel',
            width: 140,
        },
        {
            title:'会员名称',
            align:"center",
            dataIndex: 'vipName',
            width: 140,
        },
        {
            title:'价格',
            align:"center",
            dataIndex: 'price',
            width: 120,
            customRender: (text) => {
              return (text / 100).toFixed(2);
            }
        },
        {
          title: '时长',
          align: "center",
          dataIndex: 'days',
          width: 120,
          scopedSlots: { customRender: 'days' },
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
          width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      pagination: {
        onChange: (page) => {
          console.log(page)
        },
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: true,
      queryParam: {
      },
      disableMixinCreated: true
    }
  },
  created() {
    this.getVipDict();
    this.getVipList()
  },
  methods: {
    envCheck(){
      this.$refs.envCheck.open()
    },
    //获取用户vip信息
    getUserVipInfo(){
      getAction('teaching/teachingVip/getUserVipInfo').then((res) => {
        if (res.success) {
          this.vip_level.level = res.result.vipLevel
          if (this.levels.length === 0){
            console.log("levels为空")
          }
          //根据vip_level.level从levels数组获取vip_name
          for(let i in this.levels){
            let p = this.levels[i]
            if(p.value == this.vip_level.level){
              this.vip_level.name = p.text
            }
          }
          this.vip_level.vipEnd = res.result.vipEnd
        }
      })
    },
    //获取会员等级字典
    getVipDict(){
      getDict("vip_level").then((res) => {
        if (res.success) {
          this.levels = res.result;
          this.getUserVipInfo();
        }
      });
    },
    //获取会员等级列表
    getVipList() {
      this.loading = true
      this.vipDataSource = []
      getAction('teaching/teachingVip/list', {
        pageSize: 999,
      }).then((res) => {
        console.log(res)
        if (res.success) {
          for(let i in res.result){
            let p = res.result[i]
          }
          this.vipDataSource = res.result.records
          this.pagination.total = res.result.records.length
        }
        this.loading = false
      })
    },
    //购买下单
    createVipOrder(id,price) {
      console.log(id)
      let params = {};
      params.vipId = id;
      params.payMode = 1;
      params.orderPrice = price;
      postAction("/teaching/teachingOrder/createVipOrder", params)
          .then((res) => {
            if (!res.success) {
              this.$message.error(res.message);
              return;
            }
            this.payUrl = res.message;
            console.log("=================="+this.payUrl);
            this.visible = true;
            this.$nextTick(() => {
              this.generateQRCode();
            });

          })
          .catch((err) => {
            this.$message.error(err.message);
          });

    },
    //生成二维码
    generateQRCode() {
      const canvas = this.$refs.qrcodeCanvas;
      QRCode.toCanvas(canvas, this.payUrl, { width: 200 }, function (error) {
        if (error) console.error(error);
        console.log('二维码生成成功');
      });
    },
    handleCancel () {
      this.close()
    },
    handleOk () {
      this.close()
      // 刷新页面
      window.location.reload();
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
  },
};
</script>

<style>
</style>